var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCivicLeftImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 124,
    viewBox: "0 0 161 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.0107 92.5406C34.0107 92.5406 35.6107 88.1206 33.8707 84.4206C32.1307 80.7206 27.7007 79.1406 27.7007 79.1406C27.7007 79.1406 26.1007 83.5606 27.8407 87.2606C29.5907 90.9606 34.0107 92.5406 34.0107 92.5406Z",
    fill: "white",
    stroke: "#69DB7C",
    strokeWidth: 0.8458,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6911 101.511C23.6911 101.511 27.5211 100.891 29.4911 98.1406C31.4611 95.3906 30.8211 91.5606 30.8211 91.5606C30.8211 91.5606 26.9911 92.1806 25.0211 94.9306C23.0511 97.6806 23.6911 101.511 23.6911 101.511Z",
    fill: "white",
    stroke: "#69DB7C",
    strokeWidth: 0.8458,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2812 92.3706C14.2812 92.3706 17.4513 95.1706 21.1213 94.9406C24.7913 94.7106 27.5813 91.5306 27.5813 91.5306C27.5813 91.5306 24.4112 88.7306 20.7412 88.9606C17.0612 89.1906 14.2812 92.3706 14.2812 92.3706Z",
    fill: "white",
    stroke: "#69DB7C",
    strokeWidth: 0.8458,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0003 98.0106C38.0003 98.0106 36.9003 90.6606 27.5703 91.5206",
    stroke: "#69DB7C",
    strokeWidth: 0.8458,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6707 91.4106L18.7207 91.7506",
    stroke: "#69DB7C",
    strokeWidth: 0.8458,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9316 91.4906L26.3516 97.4506",
    stroke: "#69DB7C",
    strokeWidth: 0.8458,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6211 84.8906L34.0511 92.6706",
    stroke: "#69DB7C",
    strokeWidth: 0.8458,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5981 47.2595L6.00781 51.0645L9.81281 57.6547L16.4031 53.8497L12.5981 47.2595Z",
    fill: "#51CF66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7367 31.4255L93.1465 35.2305L96.9515 41.8207L103.542 38.0157L99.7367 31.4255Z",
    fill: "#51CF66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3498 13.2391C75.3098 12.9091 75.3898 12.5691 75.6098 12.2791L77.6698 9.61905C78.1098 9.04905 78.9198 8.94906 79.4898 9.38906C80.0598 9.82906 80.1598 10.6391 79.7198 11.2091L77.6598 13.8691C77.2198 14.4391 76.4098 14.5391 75.8398 14.0991C75.5498 13.8791 75.3898 13.5691 75.3498 13.2391Z",
    stroke: "#69DB7C",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.199 52.6101C110.38 52.6101 111.339 51.652 111.339 50.4701C111.339 49.2882 110.38 48.3301 109.199 48.3301C108.017 48.3301 107.059 49.2882 107.059 50.4701C107.059 51.652 108.017 52.6101 109.199 52.6101Z",
    fill: "#51CF66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9611 5.50977C16.9511 6.41977 12.8211 12.0198 13.7311 18.0298",
    stroke: "#69DB7C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.971 89.0195C112.461 97.2995 106.971 105.21 98.6914 106.7",
    stroke: "#69DB7C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8698 112.291V94.8906H44.4498V112.291L39.5098 121.541L52.8998 112.741H69.1398",
    stroke: "#69DB7C",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7785 85.6391C87.5381 85.6391 93.8285 79.3487 93.8285 71.5891C93.8285 63.8295 87.5381 57.5391 79.7785 57.5391C72.0189 57.5391 65.7285 63.8295 65.7285 71.5891C65.7285 79.3487 72.0189 85.6391 79.7785 85.6391Z",
    fill: "#37B24D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9094 83.4691C86.669 83.4691 92.9594 77.1787 92.9594 69.4191C92.9594 61.6595 86.669 55.3691 78.9094 55.3691C71.1498 55.3691 64.8594 61.6595 64.8594 69.4191C64.8594 77.1787 71.1498 83.4691 78.9094 83.4691Z",
    fill: "#B2F2BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7694 63.4492C87.3494 66.2492 81.4694 75.5292 81.4694 75.5292C81.4694 75.5292 71.0794 72.9692 71.4594 68.3792C71.9194 62.8292 77.6094 65.9092 77.6094 65.9092C77.6094 65.9092 79.6194 60.1992 83.7694 63.4492Z",
    fill: "#51CF66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7598 73.4891C70.7698 78.4991 76.4498 80.9191 81.4498 78.9091",
    stroke: "white",
    strokeWidth: 0.8458,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0496 62.6197C57.4108 62.6197 64.9996 55.0309 64.9996 45.6697C64.9996 36.3084 57.4108 28.7197 48.0496 28.7197C38.6884 28.7197 31.0996 36.3084 31.0996 45.6697C31.0996 55.0309 38.6884 62.6197 48.0496 62.6197Z",
    fill: "#40C057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6004 60.8297C58.9616 60.8297 66.5504 53.2409 66.5504 43.8797C66.5504 34.5185 58.9616 26.9297 49.6004 26.9297C40.2392 26.9297 32.6504 34.5185 32.6504 43.8797C32.6504 53.2409 40.2392 60.8297 49.6004 60.8297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6287 45.2097C45.6287 44.4297 42.8687 42.6397 40.9187 39.9297C40.7487 39.6897 40.7987 39.3597 41.0387 39.1897C41.2787 39.0197 41.6087 39.0697 41.7787 39.3097C45.8687 44.9997 53.8387 46.2997 59.5287 42.2097C59.7687 42.0397 60.0987 42.0897 60.2687 42.3297C60.4387 42.5697 60.3887 42.8997 60.1487 43.0697C56.6887 45.5597 52.4587 46.1997 48.6287 45.2097Z",
    fill: "#37B24D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9502 52.3997C61.8902 52.3797 61.8302 52.3597 61.7702 52.3197C61.5302 52.1497 61.4802 51.8197 61.6502 51.5797C63.6402 48.8297 64.4502 45.4697 63.9102 42.1097C63.3702 38.7597 61.5602 35.8097 58.8102 33.8197C58.5702 33.6497 58.5202 33.3197 58.6902 33.0797C58.8602 32.8397 59.1902 32.7897 59.4302 32.9597C62.4102 35.1197 64.3702 38.3097 64.9502 41.9397C65.5302 45.5697 64.6602 49.2097 62.5002 52.1997C62.3802 52.3797 62.1502 52.4497 61.9502 52.3997Z",
    fill: "#37B24D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1088 36.7797C56.6943 36.7797 57.1688 36.3051 57.1688 35.7197C57.1688 35.1342 56.6943 34.6597 56.1088 34.6597C55.5234 34.6597 55.0488 35.1342 55.0488 35.7197C55.0488 36.3051 55.5234 36.7797 56.1088 36.7797Z",
    fill: "#37B24D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1205 35.5397C47.706 35.5397 48.1805 35.0651 48.1805 34.4797C48.1805 33.8943 47.706 33.4197 47.1205 33.4197C46.5351 33.4197 46.0605 33.8943 46.0605 34.4797C46.0605 35.0651 46.5351 35.5397 47.1205 35.5397Z",
    fill: "#37B24D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2109 1.15039L61.5009 21.5004",
    stroke: "#69DB7C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1504 26.1502L97.1504 15.7402",
    stroke: "#69DB7C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5586 63.3397C99.5586 63.3397 131.909 82.7197 159.739 47.6697",
    stroke: "#69DB7C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.769 50.2698L159.529 47.8798L157.139 48.1298L158.049 47.0098L160.439 46.7598L160.679 49.1498L159.769 50.2698Z",
    fill: "#69DB7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 76.5L31.5 66.5",
    stroke: "#69DB7C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 121.5L20.5 108.5",
    stroke: "#69DB7C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 118.5L28.5 108.5",
    stroke: "#69DB7C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCivicLeftImage);
export default __webpack_public_path__ + "static/media/civicLeftImage.198c6765bb13fff0e8576212977c7cae.svg";
export { ForwardRef as ReactComponent };